<template>
    <div>
        <div class="header_nl">
            <a href="https://www.erickson.it/it/">
                <picture>
                    <source srcset="https://erickson-learn-resources.s3.eu-central-1.amazonaws.com/production/newsletter/logo_mob.svg" media="(max-width: 768px)">
                    <img src="https://erickson-learn-resources.s3.eu-central-1.amazonaws.com/production/newsletter/logo-desktop.svg" alt="">
                </picture>
            </a>
        </div>
        <div class="board breadcrumb_nl">
            <a href="https://www.erickson.it/it/" style="text-decoration: none;">Home</a>
            <span style="color: #b5161a;font-weight: bold;margin-left: 15px; margin-right: 15px;">/</span>
            <span>{{title}}</span>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        title: String
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
    }
}
</script>
